var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"directory"},_vm._l((_vm.anchorList),function(item,i){return _c('div',{key:'c' + i,class:[
      'dir',
      item.level === 2 ? 'son' : '',
      _vm.activeIndex === i ? 'active' : ''
    ],on:{"click":function($event){return _vm.handleClick(item, i)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }